export function addRedirectToAuthUrl(initialUrl: string, redirectTo: string | undefined) {
  let authUrl = initialUrl;
  if (redirectTo) {
    const url = new URL(authUrl);
    const existingState = url.searchParams.get("state");
    if (existingState) {
      try {
        const decodedState = JSON.parse(atob(existingState));
        decodedState.redirectTo = redirectTo;
        const newState = btoa(JSON.stringify(decodedState));
        url.searchParams.set("state", newState);
        authUrl = url.toString();
      } catch (error) {
        console.error("Could not parse existing state", error);
      }
    }
  }

  return authUrl;
}

export function getRedirectToFromState(state: string) {
  try {
    const decodedState = JSON.parse(atob(state));
    const redirectTo = decodedState.redirectTo;
    if (redirectTo && redirectTo.startsWith("/") && !redirectTo.includes("://")) {
      return redirectTo;
    }
  } catch (error) {
    console.error("Could not parse existing state", error);
  }
}
